export default __webpack_public_path__ + "677111c48f0d6b843c1b4fd3e9915a4b.png";